// extracted by mini-css-extract-plugin
export default {"desktop":"Logo-module__desktop___34U8a","mobile":"Logo-module__mobile___2HSZd"};